import React from "react";
import { useHistory } from "react-router-dom";
import { Pane, Button, MenuSection, ErrorModal, } from "@folio/stripes/components";
import { useCallout, useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import TableComponent from "../../components/TableComponent";
import CoEditionRequestFilterPane from "../../components/CoEditionRequestFilterPane";
import CoEditionRequestDetail from "./CoEditionRequestDetail";
import { CoEditionAssignModal } from "../../components/product/CoEditionAssignModal";
import { CoEditionDecisionModal } from "../../components/product/CoEditionDecisionModal";
import { approveCoEditionRequestAsCoPublisher, rejectCoEditionRequest, } from "../../api/coEditionRequestService";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { CoEditionRequestStatus, } from "../../types/Api";
import { useCoEditionRequestFilters } from "../../hooks/useCoEditionRequestFilters";
import { useCoEditionRequestsData } from "../../hooks/useCoEditionRequestsData";
import { useCoEditionRequestTable } from "../../hooks/useCoEditionRequestTable";
import { useCoEditionRequestActions } from "../../hooks/useCoEditionRequestActions";
import { usePageSize } from "../../hooks/usePageSize";
import { useModal } from "../../utils/useModal";
var CoEditionRequestList = function () {
    var _a, _b, _c;
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var callout = useCallout();
    var ky = useOkapiKy();
    var _d = useModal(), errorOpen = _d.isOpen, errorMessage = _d.message, openError = _d.openModal, closeError = _d.closeModal;
    var filtersHook = useCoEditionRequestFilters();
    var _e = usePageSize(), pageSize = _e.pageSize, createPageSizeHandler = _e.createPageSizeHandler;
    var dataHook = useCoEditionRequestsData(filtersHook.filters, pageSize);
    var actionsHook = useCoEditionRequestActions();
    var columns = useCoEditionRequestTable(actionsHook.handleRowClick).columns;
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleStatusChange = function (status) {
        dataHook.resetPageOffset();
        filtersHook.handleStatusChange(status);
    };
    var selectedRequestId = (_a = actionsHook.selectedRequest) === null || _a === void 0 ? void 0 : _a.id;
    // A request awaiting the co-publisher cannot be previewed/assigned, so it is rejected or
    // confirmed on the co-publisher's behalf through a plain note dialog.
    var isAwaitingCoPublisher = ((_b = actionsHook.selectedRequest) === null || _b === void 0 ? void 0 : _b.status) ===
        CoEditionRequestStatus.AWAITING_CO_PUBLISHER;
    var handleDecisionDone = function (messageId) {
        actionsHook.handleActionDone();
        callout === null || callout === void 0 ? void 0 : callout.sendCallout({
            type: "success",
            message: formatMessage({ id: messageId }),
        });
    };
    var handleDecisionError = function (message) {
        actionsHook.closeModal();
        openError(message);
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var goToProduct = function () {
        var _a, _b;
        var productId = (_b = (_a = actionsHook.selectedRequest) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.id;
        if (productId) {
            history.push("/bragency/products/detail/".concat(productId));
        }
    };
    return (React.createElement(React.Fragment, null,
        selectedRequestId && actionsHook.modalMode === "confirmConsent" && (React.createElement(CoEditionDecisionModal, { titleId: "ui-br-agency.co-edition.consent.agency.confirm", fieldLabelId: "ui-br-agency.co-edition.consent.agency.field.note", submitLabelId: "ui-br-agency.co-edition.consent.agency.confirm", errorMessageId: "ui-br-agency.co-edition.consent.error.approveFailed", onSubmit: function (note) {
                return approveCoEditionRequestAsCoPublisher(ky, selectedRequestId, {
                    note: note,
                });
            }, onClose: actionsHook.closeModal, onDone: function () {
                return handleDecisionDone("ui-br-agency.co-edition.consent.success.confirmedByAgency");
            }, onError: handleDecisionError })),
        selectedRequestId &&
            isAwaitingCoPublisher &&
            actionsHook.modalMode === "reject" && (React.createElement(CoEditionDecisionModal, { titleId: "ui-br-agency.co-edition.assign.modal.titleReject", fieldLabelId: "ui-br-agency.co-edition.assign.field.rejectReason", submitLabelId: "ui-br-agency.co-edition.assign.reject", errorMessageId: "ui-br-agency.co-edition.assign.error.rejectFailed", onSubmit: function (note) {
                return rejectCoEditionRequest(ky, selectedRequestId, { reason: note });
            }, onClose: actionsHook.closeModal, onDone: function () {
                return handleDecisionDone("ui-br-agency.co-edition.assign.success.rejected");
            }, onError: handleDecisionError })),
        ((_c = actionsHook.selectedRequest) === null || _c === void 0 ? void 0 : _c.id) &&
            !isAwaitingCoPublisher &&
            (actionsHook.modalMode === "assign" ||
                actionsHook.modalMode === "reject") && (React.createElement(CoEditionAssignModal, { requestId: actionsHook.selectedRequest.id, note: actionsHook.selectedRequest.note, initialMode: actionsHook.modalMode, onClose: actionsHook.closeModal, onDone: function (outcome) {
                actionsHook.handleActionDone();
                callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                    type: "success",
                    message: outcome.action === "assigned"
                        ? formatMessage({
                            id: outcome.numberLabel
                                ? "ui-br-agency.co-edition.assign.success.assigned"
                                : "ui-br-agency.title.products.panel.assign.assigned",
                        }, { value: outcome.numberLabel })
                        : formatMessage({
                            id: "ui-br-agency.co-edition.assign.success.rejected",
                        }),
                });
            }, onError: function (message) {
                actionsHook.closeModal();
                openError(message);
            } })),
        React.createElement(ErrorModal, { open: errorOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: errorMessage, onClose: closeError }),
        React.createElement(RecekPaneSet, null,
            React.createElement(CoEditionRequestFilterPane, { filterPaneIsVisible: filtersHook.filterPaneIsVisible, isAnyFilterActive: filtersHook.isAnyFilterActive, onClearFilters: handleClearFilters, filters: filtersHook.filters, onStatusChange: handleStatusChange }),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.list.pane.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }) },
                React.createElement(TableComponent, { data: dataHook.coEditionRequestsData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filtersHook.filterPaneIsVisible, toggleFilterPane: filtersHook.toggleFilterPane, source: dataHook.source })),
            actionsHook.selectedRequest && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.co-edition.detail.pane.title",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: function (_a) {
                    var _b, _c, _d;
                    var onToggle = _a.onToggle;
                    return (React.createElement(MenuSection, { label: formatMessage({ id: "ui-br-agency.action.menu.label" }), id: "actions-menu" },
                        ((_b = actionsHook.selectedRequest) === null || _b === void 0 ? void 0 : _b.status) ===
                            CoEditionRequestStatus.REQUESTED && (React.createElement(React.Fragment, null,
                            React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                                    onToggle();
                                    actionsHook.openAssignModal();
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.submit" })),
                            React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                                    onToggle();
                                    actionsHook.openRejectModal();
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.reject" })))),
                        isAwaitingCoPublisher && (React.createElement(React.Fragment, null,
                            React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                                    onToggle();
                                    actionsHook.openConfirmConsentModal();
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.agency.confirm" })),
                            React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                                    onToggle();
                                    actionsHook.openRejectModal();
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.reject" })))),
                        React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: !((_d = (_c = actionsHook.selectedRequest) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.id), onClick: function () {
                                onToggle();
                                goToProduct();
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.detail.goToProduct" }))));
                } },
                React.createElement(CoEditionRequestDetail, { request: actionsHook.selectedRequest, onGoToProduct: goToProduct }))))));
};
export default CoEditionRequestList;
